export const environment = {
  production: true,
  enableDebugLogs: true,
  enableDebugDialog: false,
  aiTemplateAnsweringEnabled: true,
  newsletterEnabled: true,
  enableUserlane: true,
  requireStagingAuth: false,
  stagingAuth: {
    username: 'admin',
    password: 'z9$(1dJ@:0tT',
  },
  directusUrl: 'https://app.selecthor.io/directus-gateway',
  keycloak: {
    enable: true,
    url: 'https://app.selecthor.io/auth', //Keycloak URL
    postLogoutRedirectUri: 'https://app.selecthor.io/start', //Frontend URL - redirect after logout
    realm: 'Selecthor',
    clientId: 'selecthor-frontend',
  },
};
